import api from "@/api/api"
import { query } from "../api/queries"
import dayjs from "dayjs"

export default {
	async fetchTemplates({ commit, rootState }, payload) {
		const res = await api({
			query: query.fetchTemplatesByType,
			variables: { ...payload }
		})

		if (!res?.data?.templates?.list) return Promise.resolve({ isSuccess: false, res, error: res?.errors?.[0]?.message })

		const dateTimeFormat = rootState.settings.dateTimeFormat
		const templates = res?.data?.templates?.list ?? []

		const decideView = template => {
			if ("marginSettings" in template) return "ViewTemplatesWkhtml"
			if ("subject" in template) return "ViewTemplatesEmailMjml"
			if ("drawings" in template) return "ViewTemplatesPdfDrawing"
			if ("bodyLiquid" in template) return "ViewTemplatesSms"
			if ("dynamicValues" in template) return "ViewTemplatesDynamic"
		}

		const formatTypeName = template => {
			if ("marginSettings" in template) return "Html to Pdf"
			if ("subject" in template) return "Email"
			if ("drawings" in template) return "PDF Drawing"
			if ("bodyLiquid" in template) return "SMS Notification"
			if ("dynamicValues" in template) return "Dynamic"
		}

		const formattedTemplates = templates.map(template => {
			let templateObject = { ...template }

			templateObject.templateView = decideView(template)
			templateObject.formattedTypeName = formatTypeName(template)
			templateObject.formattedCreatedAt = template.createdAt ? dayjs(template.createdAt).format(dateTimeFormat) : ""
			templateObject.formattedLastModifiedAt = template.lastModifiedAt
				? dayjs(template.lastModifiedAt).format(dateTimeFormat)
				: ""
			return templateObject
		})

		commit("setTemplates", formattedTemplates)
		return Promise.resolve({ isSuccess: true, res, error: null })
	}
}
